import { defineStore } from 'pinia'
import _ from 'lodash'

import type { IProgramCategoryVm } from '@/types/IProgramCategoryVm'

export const useProgramCategoriesStore = defineStore({
  id: 'useProgramCategoriesStore',
  state: () => ({
    categories: Array<IProgramCategoryVm>(),
    isLoadingCategories: false
  }),
  getters: {},
  actions: {
    async loadProgramCategories() {
      if (this.categories && this.categories.length > 0) return

      if (this.isLoadingCategories) {
        return
      }

      this.isLoadingCategories = true
      try {
        var url = `/api/Participation/GetProgramCategories`
        const response = await this.axiosFactory.withoutToken().get(url)
        this.categories = response.data.data
      } catch (error: any) {
        console.log(error.response)
      } finally {
        this.isLoadingCategories = false
      }
    }
  }
})
